// Time Slider Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Range from '../../../lib/rcslider/range.jsx'

class TimeSlider extends Component {
  static get propTypes () {
    return {
      fromTime: PropTypes.number,
      toTime: PropTypes.number,
      onChange: PropTypes.func,
      showMarker: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      fromTime: 0,
      toTime: 0,
      onChange: null,
      showMarker: false
    }
  }

  constructor (props) {
    super(props)

    this.state = {
      min: 9,
      max: 17
    }

    this._data = this._getTimeData(props.fromTime, props.toTime)
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    this._data = this._getTimeData(nextProps.fromTime, nextProps.toTime)
  }

  render () {
    const { fromHour, toHour } = this._data
    const markerStyles = { 'margin-bottom': '-10' }
    let marks = {}
    if (this.props.showMarker) {
      marks = {
        9: { style: markerStyles, label: '17.00' },
        10: { style: markerStyles, label: '16.00' },
        11: { style: markerStyles, label: '15.00' },
        12: { style: markerStyles, label: '14.00' },
        13: { style: markerStyles, label: '13.00' },
        14: { style: markerStyles, label: '12.00' },
        15: { style: markerStyles, label: '11.00' },
        16: { style: markerStyles, label: '10.00' },
        17: { style: markerStyles, label: '09.00' }
      }
    }

    return (
      <div className='time-slider'>
        <Range
          defaultValue={[fromHour, toHour]}
          min={this.state.min}
          max={this.state.max}
          vertical
          allowCross={false}
          onChange={this._onSliderChange.bind(this)}
          marks={marks}
        />
      </div>
    )
  }

  /* Private Functions */
  _getTimeData (fromTime, toTime) {
    return {
      fromHour: fromTime ? this._getHourFromTime(fromTime) : 9,
      toHour: toTime ? this._getHourFromTime(toTime) : 17
    }
  }

  _getHourFromTime (timeInMins) {
    return Math.floor(timeInMins / 60)
  }

  _onSliderChange (values) {
    this._data.fromHour = values[0]
    this._data.toHour = values[1]

    if (this.props.onChange) {
      const fromTime = this._data.fromHour * 60
      const toTime = this._data.toHour * 60

      this.props.onChange(fromTime, toTime)
    }
  }
}

export default TimeSlider
